import React from 'react'
import Button from "@mui/material/Button";
import Footer from '../components/footer'
import Header from '../components/header'
import { Outlet } from 'react-router-dom';
import { useTheme } from '@emotion/react';

export default function Layout() {

  const h = document.body.scrollHeight;
  const documentHeight = document.documentElement.clientHeight;
  const [show, setShow] = React.useState(false);

  const theme = useTheme();
  //header背景没透明因为，地图没有顶上天
  
  return (
    <div className='w-screen h-screen' style={{ backgroundColor: theme.palette.primary.darkwhite }}>
      {/* <div className=' w-1/2 h-1/3 shadow-md bg-white'> */}
      {/* <Button >这是一个按钮</Button> */}
      <Header sx={{ zIndex: 1 }}></Header>
        <Outlet />
      <Footer sx={{ zIndex: 1, display: 'none' }}></Footer>
      {/* </div> */}
    </div>
  )
}
